import { FormBuilder, FormGroup } from '@angular/forms';
import { FormatValidationService } from '@xpo-ltl/common-services';
import { EmailEntryFormBuilder } from '../../../../../../lib/src/lib/notes-emails/public_api';
import { CancelationEmailDialogFormNamesEnum } from '../../../../enums';

export class CancelationEmailDialogFormBuilder {
  static create(fb: FormBuilder, formatValidationService: FormatValidationService): FormGroup {
    return fb.group({
      [CancelationEmailDialogFormNamesEnum.EMAIL]: EmailEntryFormBuilder.create(fb, formatValidationService),
    });
  }
}
